module.exports = __webpack_public_path__ + "img/bracket-9.d424e6e0.svg";